
import { useRef, useEffect, useCallback } from 'react';
import { useBoardPresence } from '@/contexts/BoardPresenceContext';

interface UseViewportCardTrackingOptions {
  cardId: string;
  threshold?: number;
}

export const useViewportCardTracking = ({
  cardId,
  threshold = 0.1
}: UseViewportCardTrackingOptions) => {
  const elementRef = useRef<HTMLDivElement | null>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const isVisibleRef = useRef(false);
  const { setUserStatus } = useBoardPresence();

  const handleIntersection = useCallback((entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      const isVisible = entry.isIntersecting;
      
      if (isVisibleRef.current !== isVisible) {
        isVisibleRef.current = isVisible;
        
        if (isVisible) {
          // User is viewing this card
          //setUserStatus("viewing", cardId);
        }
        // Note: We don't clear status when card leaves viewport as user might still be on the board
      }
    });
  }, [cardId, setUserStatus]);

  useEffect(() => {
    if (!elementRef.current) return;

    observerRef.current = new IntersectionObserver(handleIntersection, {
      threshold,
      rootMargin: '50px' // Start tracking slightly before card enters viewport
    });

    observerRef.current.observe(elementRef.current);

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [handleIntersection, threshold]);

  return elementRef;
};
